function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/manager/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const managerRoutes = [
  {
    path: '/manager/dashboard',
    component: view('Dashboard'),
    name: 'manager.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/manager/sales-order-tracker/:status?',
    component: view('SalesOrderTracker'),
    name: 'manager.sales-order-tracker',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order Tracker',
          active: true
        }
      ]
    }
  }
]

export default managerRoutes
